import { Badge } from "@/components/ui/badge";

export type RiskRatingName = "low" | "moderate" | "high";

const BADGE_STYLES: Record<RiskRatingName, string> = {
  low: "bg-green-100 text-green-800 border-green-200",
  moderate: "bg-amber-100 text-amber-800 border-amber-200",
  high: "bg-red-100 text-red-800 border-red-200",
};

interface RiskRatingBadgeProps {
  ratingName?: string | null;
}

export function RiskRatingBadge({ ratingName }: RiskRatingBadgeProps) {
  const key = (ratingName as RiskRatingName) ?? "moderate";
  const styles = BADGE_STYLES[key] ?? BADGE_STYLES.moderate;
  const label = key.charAt(0).toUpperCase() + key.slice(1);

  return (
    <Badge variant="outline" className={styles}>
      {label}
    </Badge>
  );
}
